<template>
  <div>
<b-tabs type="is-boxed" expanded>
            <b-tab-item label="GST Settings">
 <div class="columns" v-for="tax in taxes" :key="tax.cgst">
    <div class="column" > 
      <b-field label="GST No.">
        <b-input
             icon="calculator"
            type="text"
            v-model.number="tax.gstNo"
            placeholder="e.g. 1234567891234567"
            required
            disabled>
        </b-input>
      </b-field>
    </div>
    <div class="column">
    <b-field label="SGST (%)">
        <b-input icon="hotel" v-model.number="tax.sgst" disabled></b-input>
      </b-field>
     </div>
    <div class="column">
    <b-field label="CGST (%)">
        <b-input icon="hotel" v-model.number="tax.cgst" disabled></b-input>
      </b-field>
     </div>
    <!-- <div class="column" disabled>
       <b-field label=" ">
   <a class="button is-primary" :class="{'is-loading': issaveTax}" @click="saveTax" disabled>Save</a> </b-field>
   </div> -->
 
     </div>
            </b-tab-item>
            <b-tab-item label="Service Destinations">
  <div class="columns is-multiline">
   
    <div class="column is-3">
      <div class="box has-text-centered">
        <a class="button  is-small" @click="openAddZipcodeDialog">
          <span class="icon is-small" style="color:white;">
            <i class="fas fa-plus"></i>
          </span>
          <span style="color:white;">Add</span>
        </a>
      </div>
    </div>
    <div class="column is-3" v-for="destination in destinations" :key="destination.name">
      <div class="box zipcode-container">
        
        <p class="has-text-centered">{{destination.name}}</p>
        <div>
          <div>
             <i class="fa fa-eye icon" @click="openAddZipcodeDialog(destination)" title="Edit" ></i>
             <i class="fa fa-trash-alt icon" @click="deleteDestination(destination)" title="Delete" ></i>
          </div>
        </div>
      </div>
    </div>
  </div>
            </b-tab-item>
            <b-tab-item label="Hotel Types">
  <div class="columns is-multiline">
    <div class="column is-3">
      <div class="box has-text-centered">
        <a class="button is-small" @click="openAdHoteltypeDialog">
          <span class="icon is-small">
            <i class="fas fa-plus" style="color:white;"></i>
          </span>
          <span style="color:white;">Add</span>
        </a>
      </div>
    </div>
    <div class="column is-3" v-for="hotelType in hotelTypes" :key="hotelType.typeName">
      <div class="box zipcode-container">
        
        <p class="has-text-centered">{{hotelType.typeName}}</p>
       <div>
          <div>
             <i class="fa fa-eye icon" @click="openAdHoteltypeDialog(hotelType)" title="Edit" ></i>
             <i class="fa fa-trash-alt icon" @click="deleteHoteltype(hotelType)" title="Delete" ></i>
          </div>
        </div>
      </div>
    </div>
  </div>
            </b-tab-item>
            <b-tab-item label="Admin">
    <div class="columns is-multiline">
    <div class="column is-3">
      <div class="box has-text-centered">
        <a class="button is-small" @click="openAdHoteltypeDialog">
          <span class="icon is-small">
            <i class="fas fa-plus" style="color:white;"></i>
          </span>
          <span style="color:white;">Add</span>
        </a>
      </div>
    </div>
    <div class="column is-3" v-for="user in data" :key="user.name">
      <div class="box zipcode-container">
        
        <p class="has-text-centered"><strong>{{user.name}}</strong></p>
       <div>
          <div>
             <i class="fa fa-eye icon" @click="openAdHoteltypeDialog(user)" title="Edit" ></i>
             <i class="fa fa-trash-alt icon" @click="deleteHoteltype(user)" title="Delete" ></i>
          </div>
        </div>
      </div>
    </div>
   
    
  </div>
              
            </b-tab-item>
        </b-tabs>
      

      
        
    
    </div>

</template>

<script>
import SettingsService from './service';
import ManageDestination from './ManageDestination';
import ManageHoteltypes from './ManageHoteltypes';
import UsersService from '../users/service';
import Firebase from '../../lib/Firebase';
import Firestore from '../../lib/Firestore';

export default {
  name: 'settings',

  created() {
    
    this.fetchTax();
    this.fetchHotelTypes();
    this.fetchDestinations();
    this.logeduser();
  },
  props: ['city'],
  data() {
    return {
      savingCityInformation: false,
      name: null,
      isHotelsLoading: false,
      gstNo : null,
      tax : null,
      taxes : null,
      hotelTypes : null,
      destinations : null,
      issaveTax : false,
      sgst: null,
      cgst: null,
      name : '',
      data : null,
    };
  },

  methods: {

      fetchTax() {
      SettingsService.tax().then(data => {
        this.taxes = data;
        this.isLoading = false;
        console.log(this.taxes);
      });
    },
      fetchHotelTypes() {
      SettingsService.hotelTypes().then(data => {
        this.hotelTypes = data;
        this.isLoading = false;
       
      });
    },
      fetchDestinations() {
      SettingsService.destinations().then(data => {
        this.destinations = data;
        this.isLoading = false;
        
      });
    },

      openAddZipcodeDialog(destination) {
       
      this.$modal.open({
        parent: this,
        props: {
          destination: destination
        },
        component: ManageDestination,
        hasModalCard: true
      });
    },
      openAdHoteltypeDialog(hotelType) {
      this.$modal.open({
        parent: this,
        props: {
          hotelType: hotelType
        },
        component: ManageHoteltypes,
        hasModalCard: true
      });
    },

    deleteDestination(destination) {
      this.isHotelsLoading = true
      
    this.$dialog.confirm({
    message: 'Sure to delete destination?',
        onConfirm: () => {
      SettingsService.deletDestination(destination.docId).then(() => {
        this.destinations = this.destinations.filter(
          destination => destination.docId !== destination.docId
        );
         this.isHotelsLoading = false
        this.$toast.open('Destination deleted successfully');
        location.reload();
         });
        }
      });
    },
    deleteHoteltype(hotelType) {
      
      this.$dialog.confirm({
      message: 'Sure to delete hotelType?',
      onConfirm: () => {
      SettingsService.deleteHoteltype(hotelType.docId).then(() => {
        this.hotelTypes = this.hotelTypes.filter(
          hotelType => hotelType.docId !== hotelType.docId
        );
        
        this.$toast.open('Hotel type deleted successfully');
        location.reload();
         });
        }
      });
    },
      saveTax() {
         issaveTax : true
      SettingsService.saveTax(this.tax.gstNo, this.tax.sgst, this.tax.cgst).then(() => {
         issaveTax : false
      this.$toast.open({
                    message: 'GST Details saved successfully',
                    type: 'is-success'
                });
      });
    },
    
    logeduser(){
     /*  var user = Firebase.auth().currentUser;
      var name, email, photoUrl, uid, emailVerified;
          if (user != null) {
                let docRef = Firebase.firestore().collection("users").doc(user.uid);
                docRef.get().then(doc => {
             this.data = doc.data();
             console.log(data.name);
              })
          } */
        this.users = null;
        UsersService.allAdmin().then(users => {
        this.data = users;
        this.isUsersLoading = false;

      });
    }


  }, 

     computed: {
             
      

  }
};
</script>
<style scoped>
.zipcode-container {
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/pages/settings/Settings.vue